import { parseBool } from "../../lib/calculations";
import { map } from "rxjs/operators";
import { combineLatest, from, Observable, ReplaySubject } from "rxjs";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { SubmitTriggerSettings } from "@cs-ts/submit-trigger-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class SubmitTriggerDef extends BaseElementDef<SubmitTriggerSettings, FormDefinitionItem<SubmitTriggerSettings>, FormItem> {
    declare _submitButtons$: ReplaySubject<{ text: string; trigger: string | undefined; order: number | undefined }[]>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<SubmitTriggerSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFSubmitTrigger"; // TODO - not hardcoded?
    }

    submitButtons$() {
        const mapText = (text: string) => [{ text, trigger: this.definition.settings.triggerKey, order: this.definition.settings.order }];
        const coalesce = (...array: (string | undefined)[]) => array.reduce((acc, cur) => (acc == null || /^\s*$/.test(acc) ? cur : acc));
        const text = coalesce(this.definition.settings.buttonText, this.definition.settings.displayLabel)!;
        const calculationIds = ["buttonTextCalculationId", "displayCalculationId"] as const;

        if (calculationIds.some(calcId => this.definition.settings[calcId] != null)) {
            if (this._submitButtons$ == null) {
                this._submitButtons$ = new ReplaySubject(1);
                const observables = {
                    buttonTextCalculationId: new Observable<string[]>(),
                    displayCalculationId: new Observable<string[]>(),
                };

                for (const calculationId of calculationIds) {
                    const calcId = this.definition.settings[calculationId]!;
                    observables[calculationId] = this.resolveCalculation(calcId);
                }
                const r = combineLatest([observables.buttonTextCalculationId, observables.displayCalculationId]).pipe(map(([buttonText, visible]) => (parseBool(visible[0]) === 1 || visible[0] == null ? mapText(coalesce(buttonText[0], text)!) : [])));
                r.subscribe(this._submitButtons$);
            }
            return this._submitButtons$;
        } else {
            return from([mapText(text)]);
        }
    }
}
